module.exports = __webpack_public_path__ + "media/images/about/course-e4cca11161faaed35e740896954602c2.png";